export const Fill = {
  Scale: 'c_scale',
  Thumb: 'c_thumb',
};

export const Face = {
  None: 'none',
  Face: 'g_face',
};
